export const log = (...logs) => {
	const isPDN = process.env.ENVIRONMENT === 'PDN'
	if (isPDN) return

	console.log('--------------------')
	console.log('NOL LOG > ', ...logs)
	console.log('--------------------')
}